import dynaFormsApi from '@elab/core/utils/dynaForms/api';
import HTTPClient from '@elab/core/utils/HTTPClient';

export async function loadPinCodeRequired(dto) {
    const uri = dynaFormsApi.getFormMetadata('pincode-required');
    const response = await HTTPClient().postJson(uri, dto);
    if (!response.ok) {
        throw new Error(`Failed loading ${uri} (${response.status})`);
    }

    const data = await response.json();

    return data.pinCodeRequired;
}
